import ReactDOM from 'react-dom/client';
import { App } from 'src/app/App';
import './shared/styles/index.scss';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(<App />);
